module.exports = __webpack_public_path__ + "img/vk.a7597edc.svg";